/**
 * Phone numbers: the country codes the forms offer and how many digits a
 * number has after the code. UA (+380) numbers have 9 digits, all others 10.
 */
export const DEFAULT_PHONE_DIGITS = 10;

export const COUNTRY_CODES = [
  { value: "+49", label: "DE" },
  { value: "+91", label: "IN" },
  { value: "+380", label: "UA", digits: 9 },
  { value: "+1", label: "US" },
];

/** Digits after the country code (10 unless the code says otherwise). */
export const phoneDigits = (countryCode) =>
  COUNTRY_CODES.find((c) => c.value === countryCode)?.digits ?? DEFAULT_PHONE_DIGITS;

/** Input mask: "+380 (###) ###-###" for 9 digits, "+1 (###) ###-####" for 10. */
export const phoneFormat = (countryCode) =>
  phoneDigits(countryCode) === 9
    ? `${countryCode} (###) ###-###`
    : `${countryCode} (###) ###-####`;

/** "(501) 234-567" / "(555) 123-4567": same groups as the input mask */
export const formatPhoneDigits = (digits = "") =>
  `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;

/**
 * Split a saved number ("+380501234567") into its country code and digits.
 * A known code whose digit count matches wins; otherwise the last 10 digits
 * are the number (the previous behaviour).
 */
export const splitPhone = (phone) => {
  const known = [...COUNTRY_CODES]
    .sort((a, b) => b.value.length - a.value.length)
    .find((c) => phone.startsWith(c.value) && phone.length - c.value.length === phoneDigits(c.value));
  const size = known ? phoneDigits(known.value) : DEFAULT_PHONE_DIGITS;
  return { countryCode: phone.slice(0, phone.length - size), number: phone.slice(phone.length - size) };
};
